export default __webpack_public_path__ + "madfit-screen-seventh@2x.def458be.png";